import { render, staticRenderFns } from "./FamilyShowEdit.vue?vue&type=template&id=9fd4cf02&lang=pug&"
import script from "./FamilyShowEdit.vue?vue&type=script&lang=js&"
export * from "./FamilyShowEdit.vue?vue&type=script&lang=js&"
import style0 from "./FamilyShowEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FamilyShowEdit.vue"
export default component.exports